export enum ValidationResult {
  NO_VALIDATION,
  VALID,
  INVALID
}
